// TODO: Clear up how paginationOptions work and maybe
// use that instead of count and currentPage. From what
// I 've seen paginationOptions has page and size keys so
// even if we use them we would need to refactor other parts
// of the code
const initialState = {
  all: {
    isLoading: false,
    error: '',
    data: [],
    count: 0,
    currentPage: 1,
    searchTerm: '',
  },
  upload: {
    isLoading: false,
    error: '',
    files: [],
  },
  show: {
    isLoading: false,
    isSaving: false,
    searchTerm: '',
    theme: 'default',
    presentedId: null,
  },
};

export default initialState;
